// Tên loại phiếu trong hộp xác nhận khôi phục; phiếu nào được khôi phục do backend quyết định (useCoTheKhoiPhuc)
export const LOAI_PHIEU_KHOI_PHUC = {
  0: "thu ngoại lệ",
  1: "đóng lãi",
  3: "trả lãi nhận vay",
  4: "thu nhận vay",
  10: "chi ngoại lệ",
  11: "tất toán",
  13: "tất toán nhận vay",
  16: "thanh lý tài sản",
  17: "trả bớt gốc",
  18: "trả bớt gốc nhận vay",
  19: "cấp quỹ",
  20: "xuất quỹ",
  21: "vay thêm",
  25: "lãi quá hạn",
  54: "thu bán hàng",
  71: "vay thêm nhận vay",
};
